import React, { useRef, useState } from "react";
import Title from "../../new-components/title/Title";
import HeaderInner from "../../Components/HeaderInner";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TbMobiledata, TbWorld } from "react-icons/tb";
import { MdOutlineDateRange, MdSignalCellularAlt } from "react-icons/md";
import { IoIosPricetag } from "react-icons/io";
import { Button, Modal, Form, Row, Col, Toast } from "react-bootstrap";
import { VscLayoutMenubar } from "react-icons/vsc";
import { CiCircleInfo } from "react-icons/ci";
import { FaRegNewspaper } from "react-icons/fa6";
import PhoneInputComponent from "../../Components/PhoneInputComponent";

// ✅ Formik + Yup
import { useFormik } from "formik";
import * as Yup from "yup";
import { BookSim, bookSimReq } from "../../API/Sim";
import { toast } from "react-toastify";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  phone: Yup.string()
    .min(7, "Phone number is too short")
    .required("Phone number is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  quantity: Yup.number()
    .min(1, "Minimum quantity is 1")
    .required("Quantity is required"),
});

const E_SimDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const { company_id, type } = useParams();

  const lang = localStorage.getItem("lang");
  const new_design = localStorage.getItem("new_design");
  const theme = new_design === "true";

  const pkg_details = location.state?.pkg;
  const operator = location.state?.operator;
  const loaderRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState();

  const handleLoad = () => {
    // Hide the loading view when the iframe is loaded
    if (loaderRef.current) {
      loaderRef.current.style.display = "none"; // Hide the loader by setting display to 'none'
      loaderRef.current.style.visibility = "hidden"; // Hide the loader by setting visibility to 'hidden'

      loaderRef.current.remove();
    }
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      phone: "",
      email: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const res = await bookSimReq(room_uuid, lang, {
          quantity: values.quantity,
          id: pkg_details.id.toString(),
          name: values.name,
          phone: values.phone,
          email: values.email,
          redirect_url: `https://${window.location.host}/${room_uuid}/CheckoutCallback`,
          type: "sim",
          sharing_option: ["link"],
        });
        console.log("Booking successful", res.data);

        if (res.data.status) {
          if (res?.data?.data.is_embedded) {
            setPaymentUrl(res?.data?.data?.payment_url);
          } else {
            window.location.href = res.data.data.payment_url;
          }
        } else {
          toast.error(res.data?.message);
        }
      } catch (err) {
        console.error("Booking error", err);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className={`${theme && "food"} ${lang === "AR" && "arabic"}`}>
      {theme ? (
        <Title title={t("eSIM")} />
      ) : (
        <HeaderInner headerName={t("eSIM")} />
      )}

      <main className="box_food image_services home-main bg-white back-white">
        <Toast ref={toast} position="bottom-center" />
        <div className="sim-details-card">
          <p
            style={{
              fontWeight: "bold",
              fontSize: "18px",
              marginBottom: "12px",
            }}
          >
            {operator.title}
          </p>

          {[
            { icon: <TbWorld />, label: t("Coverage"), value: operator.title },
            {
              icon: <TbMobiledata />,
              label: t("Data"),
              value: pkg_details.data,
            },
            {
              icon: <MdOutlineDateRange />,
              label: t("Validity"),
              value: `${pkg_details.day} ${t("Days")}`,
            },
            {
              icon: <IoIosPricetag />,
              label: t("Price"),
              value: `${pkg_details.retail_price} $`,
            },
          ].map((item, idx) => (
            <div
              key={idx}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <span style={{ marginRight: "6px" }}>{item.icon}</span>
                <span>{item.label}</span>
              </div>
              <span>{item.value}</span>
            </div>
          ))}

          <div style={{ marginTop: "20px" }}>
            <p
              style={{
                fontWeight: "bold",
                fontSize: "18px",
                marginBottom: "12px",
              }}
            >
              {t("additional information")}
            </p>

            {operator.coverages?.[0]?.networks && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <MdSignalCellularAlt style={{ marginRight: "6px" }} />
                  <span>{t("Networks")}</span>
                </div>
                <span>
                  {operator.coverages[0].networks
                    .map((net) => `${net.name} (${net.types.join(", ")})`)
                    .join(", ")}
                </span>
              </div>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <VscLayoutMenubar style={{ marginRight: "6px" }} />
                <span>{t("Plan Type")}</span>
              </div>
              <span>{operator.plan_type}</span>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <FaRegNewspaper style={{ marginRight: "6px" }} />
                <span>{t("eKYC")}</span>
              </div>
              <span>
                {operator.is_kyc_verify ? t("Required") : t("Not Required")}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  minWidth: "20%",
                }}
              >
                <CiCircleInfo style={{ marginRight: "6px" }} />
                <span>{t("Other Info")}</span>
              </div>
              <span style={{ textAlign: "right" }}>{operator.other_info}</span>
            </div>
          </div>

          {/* FORM RENDERED DIRECTLY */}
          <Form
            onSubmit={formik.handleSubmit}
            style={{ marginTop: "20px" }}
            className=" rounded-form"
          >
            <Row className="justify-content-center">
              <Col xs="12">
                <Form.Group className="mb-3" controlId="formName">
                  <Form.Control
                    type="text"
                    placeholder={t("Your Name")}
                    name="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={formik.touched.name && !!formik.errors.name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col xs="12">
                <Form.Group className="mb-3">
                  <PhoneInputComponent
                    value={formik.values.phone}
                    onChange={(value) => formik.setFieldValue("phone", value)}
                    onBlur={() => formik.setFieldTouched("phone", true)}
                    className={
                      formik.touched.phone && formik.errors.phone
                        ? "is-invalid"
                        : ""
                    }
                  />
                  {formik.touched.phone && formik.errors.phone && (
                    <div className="invalid-feedback d-block">
                      {formik.errors.phone}
                    </div>
                  )}
                </Form.Group>
              </Col>

              <Col xs="12">
                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Control
                    type="email"
                    placeholder={t("Your Email")}
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={formik.touched.email && !!formik.errors.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.email}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col xs="12">
                <Form.Group className="mb-3" controlId="formQuantity">
                  <Form.Control
                    type="number"
                    min="1"
                    name="quantity"
                    placeholder={t("Quantity")}
                    value={formik.values.quantity}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.touched.quantity && !!formik.errors.quantity
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.quantity}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            {!paymentUrl && (
              <div className="text-center">
                <Button
                  disabled={loading}
                  className="reg-btn book"
                  type="submit"
                >
                  {t("Order")}
                </Button>
              </div>
            )}

            {paymentUrl && (
              <div className="payment-iframe">
                <div
                  className="d-flex justify-content-center m-5"
                  ref={loaderRef}
                >
                  <div
                    className="loader"
                    style={{
                      borderColor: "lightgray",
                      borderRightColor: "#000000",
                    }}
                  ></div>
                </div>
                <iframe
                  loading="lazy"
                  src={paymentUrl}
                  width="100%"
                  height="600px" // Set a reasonable minimum height
                  title="Payment Preview"
                  scrolling="yes" // Allow scrolling
                  onLoad={handleLoad}
                  style={{ border: "none", minHeight: "600px" }}
                />
              </div>
            )}
          </Form>
        </div>
      </main>
    </div>
  );
};

export default E_SimDetails;
